<template>
  <div>
    <div class="d-flex align-items-center">
      <h5 class="mr-3">¿Qu&eacute; son los pasos?</h5>
      <vs-button class="p-3" icon-after icon="info" @click="$refs.stepsInfo.show()">
        Explicaci&oacute;n
      </vs-button>
      </div>
    <b-modal
      title="Pasos"
      size="lg"
      centered
      no-close-on-backdrop
      hide-footer
      ref="stepsInfo"
    >
      <p>
        Los pasos son los participantes del proceso de aprobaci&oacute;n.
        Para estos participantes se pueden definir 3 roles:
      </p>
      <p>
        <ul>
          <li>
            <b>1. Revisor: </b>Es un rol especial, que s&oacute;lo
            permite a alguien emitir una opini&oacute;n. A&uacute;n
            cuando su opini&oacute;n sea rechazar, el proceso seguir&aacute;
            avanzando.
          </li>
          <br>
          <li>
            <b>2. Aprobador:</b> Es un rol que permite aprobar o rechazar
            el proceso. A diferencia del revisor, cuando un Aprobador rechaza,
            el proceso de aprobaci&oacute;n finaliza.
          </li>
          <br>
          <li>
            <b>3. Firmante: </b> El Rol firmante es para aquellos aprobadores que
            deben incorporar Firma Electr&oacute;nica a los documentos que son parte
            del proceso de aprobaci&oacute;n. Al igual que el aprobador, si un Firmante
            rechaza el documento, esto terminar&aacute; el proceso.
          </li>
        </ul>
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'StepsInfo'
};
</script>
